import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigService } from '@mona/config';
import { DrawerNavItem } from '@mona/ui';

/**
 * ExternalResourcesHeaderComponent
 */
@Component({
    selector: 'ui-drawer-nav-subitem',
    templateUrl: './drawer-nav-subitem.component.html',
    styleUrls: ['./drawer-nav-subitem.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DrawerNavSubItemComponent {
    /** external resource data */
    @Input() public subItem!: Omit<DrawerNavItem, 'icon'>;
    /** active sub item id */
    @Input() public activeSubItemId!: string;
    /** open resource emitter */
    @Output() public handleEvent: EventEmitter<Omit<DrawerNavItem, 'icon'>> = new EventEmitter<
        Omit<DrawerNavItem, 'icon'>
    >();

    showDefaultIcon!: boolean;
}
